/**
 * Substitute script placeholder tokens with the live call's people at DISPLAY
 * TIME only. Never mutate stored script data — call this when rendering spoken
 * lines (and workshop-pitch / not-fit text) in the cockpit and summary.
 *
 * Tokens handled:
 *   [Name], [name], [Client Name]  -> prospect's name
 *   [your name], [Your Name]       -> caller's FIRST name
 *
 * If a value is missing/blank, its token is left as-is so the caller can see
 * what still needs filling.
 *
 * @param {string} text
 * @param {{ prospectName?: string, callerName?: string }} opts
 * @returns {string}
 */
export function fillPlaceholders(text, { prospectName, callerName } = {}) {
  if (!text || typeof text !== 'string') return text;

  let out = text;

  const prospect = (prospectName || '').trim();
  if (prospect) {
    // [Name], [name], [Client Name] — case-insensitive on the variants we ship.
    out = out.replace(/\[(?:name|client name)\]/gi, prospect);
  }

  // Caller token resolves to the FIRST name only (split on whitespace).
  const callerFirst = (callerName || '').trim().split(/\s+/)[0] || '';
  if (callerFirst) {
    out = out.replace(/\[your name\]/gi, callerFirst);
  }

  return out;
}
